export default [
  {
    path: '/feedback/index',
    name: 'feedback',
    component: () => import('@/view/feedback/index.vue'),
    meta: { pageName: 'page_feedback' }
  },
  {
    path: '/feedback/result',
    name: 'feedbackResult',
    component: () => import('@/view/feedback/result.vue'),
    meta: { pageName: 'page_feedback_reslut' }
  },
  {
    
    path: '/feedback/evaluate',
    name: 'feedbackEvaluate',
    component: () => import('@/view/feedback/evaluate.vue'),
    meta: { pageName: 'page_feedback_evaluate' }
  }

]